import * as yup from 'yup';

const nameValidator = yup
  .string()
  .trim()
  .min(3, 'Name must be at least 3 characters long');

export default nameValidator;
